"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlags = void 0;
const react_1 = require("react");
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const use_metrics_hook_1 = require("./use-metrics.hook");
const useFlags = (props) => {
    const onFlagRender = (0, use_metrics_hook_1.useMetrics)(props);
    const [contextQueryParams, setContextQueryParams] = (0, react_1.useState)(props.initialContext ? (0, utils_1.toQueryParams)(props.initialContext.userId, props.initialContext.properties) : "");
    const [flagsReady, setFlagsReady] = (0, react_1.useState)(false);
    const buildFetchFlagsUrl = () => `${props.url}?appName=${props.appName}&${contextQueryParams}`;
    const fetchFlagsUrl = (0, react_1.useMemo)(buildFetchFlagsUrl, [contextQueryParams]);
    const { data, error } = (0, swr_1.default)([fetchFlagsUrl, props.token, "GET"], utils_1.fetcher, {
        refreshInterval: (0, utils_1.getRefreshInterval)(props.refreshIntervalSeconds) * 1000,
        revalidateOnFocus: false,
        refreshWhenHidden: false,
        revalidateIfStale: false,
        revalidateOnReconnect: false,
        refreshWhenOffline: false,
    });
    (0, react_1.useEffect)(() => {
        if (!flagsReady && data) {
            setFlagsReady(true);
        }
    }, [data]);
    const updateFetchFlagsQueryParams = (userId, properties) => {
        const queryParams = (0, utils_1.toQueryParams)(userId, properties);
        if (contextQueryParams !== queryParams)
            setContextQueryParams(queryParams);
    };
    return {
        flags: (0, utils_1.toFlagsObject)(data?.toggles || []),
        flagsReady,
        flagsError: error,
        updateFlagsContext: updateFetchFlagsQueryParams,
        onFlagRender,
    };
};
exports.useFlags = useFlags;
//# sourceMappingURL=use-flags.hook.js.map